











































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositPaymentOrderSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositPaymentOrderSettings';
import AccountDepositPaymentOrderSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/PaymentOrders/AccountDepositPaymentOrderSettingsEditDialog.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositPaymentOrderSettingsRead', components: { AccountDepositPaymentOrderSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    settings: AccountDepositPaymentOrderSettings;

    PermissionUtils = PermissionUtils;

    async deleteDepositPaymentOrderAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositPaymentOrderSettings();
        }
    }

}
